import { ChangeEventHandler, FC } from 'react';

import { toast } from 'sonner';
import useSWRMutation from 'swr/mutation';

import Checkbox from '@mui/material/Checkbox';

import { broadcastNotificationService } from 'v2/api/broadcastNotificationService';
import { BroadcastNotification } from 'v2/types/BroadcastNotificationModel';
import { handleHttpError } from 'v2/utils';

interface PinnedCheckboxColumnProps {
  item: BroadcastNotification;
  onRevalidate: VoidFunction;
}

export const PinnedCheckboxColumn: FC<PinnedCheckboxColumnProps> = ({ item, onRevalidate }) => {
  const { trigger: update, isMutating } = useSWRMutation(
    ['updateBroadcastNotification', item.id],
    broadcastNotificationService.update
  );

  const handleChange: ChangeEventHandler<HTMLInputElement> = async (e) => {
    const next = e.target.checked;
    try {
      await update({
        categorySubType: item.categorySubType,
        data: item.data,
        metadata: item.metadata,
        isPinned: next,
      });
      toast.success(next ? 'Notification pinned' : 'Notification unpinned');
      onRevalidate();
    } catch (error) {
      handleHttpError(error);
    }
  };

  return <Checkbox checked={item.isPinned} disabled={isMutating} onChange={handleChange} />;
};
